<app-wizard-bar-nav [stepIsDirty]="false"></app-wizard-bar-nav>

<app-contract-details></app-contract-details>